function update_url(resp) {
    if (window.history && "pushState" in window.history) {
        const url = resp.data.data.url;
        if (!url) return;
        window.history.pushState(null, "", url);
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical !== null) {
            canonical.href = url;
        }
    }
}

function groupBy(objectArray, property, value) {
    return objectArray.reduce(function (acc, obj) {
        const key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj[value]);
        return acc;
    }, {});
}

function getFormData(filter_form) {
    let formData = new FormData(filter_form);
    let object = [];
    formData.forEach(function (value, key) {
        const o = {
            name: key,
            value: value,
        };
        object.push(o);
    });
    const pieces = groupBy(object, "name", "value");
    formData = new FormData();
    for (const piece in pieces) {
        if (pieces.hasOwnProperty(piece)) {
            formData.append(piece, pieces[piece].join("|"));
        }
    }
    return formData;
}

function oiFilterDisableForm(oi_filter_form) {
    if (oi_filter_form) {
        for (let i = 0; i < oi_filter_form.elements.length; i++) {
            oi_filter_form.elements[i].setAttribute("disabled", "disabled");
        }
        const to_disable = oi_filter_form.querySelectorAll(".oi-disable-while-pending");
        to_disable.forEach(el => el.setAttribute("disabled", "disabled"));

        const model_filters = oi_filter_form.querySelectorAll(".model-filters");
        model_filters.forEach(el => el.style.opacity = "0.6");
    }
}

function oiFilterEnableForm(oi_filter_form) {
    if (oi_filter_form) {
        setTimeout(() => {
            for (let i = 0; i < oi_filter_form.elements.length; i++) {
                oi_filter_form.elements[i].disabled = false;
                oi_filter_form.elements[i].removeAttribute("disabled");
            }
            const to_disable = oi_filter_form.querySelectorAll(".oi-disable-while-pending");
            to_disable.forEach(el => {
                el.disabled = false;
                el.removeAttribute("disabled");
            });
            const model_filters = oi_filter_form.querySelectorAll(".model-filters");
            model_filters.forEach(el => el.style.opacity = "1");
        }, 500);
    }
}

function oiFilterAjaxBeforesend(oi_filter_form, from_infinite) {
    if (!from_infinite) {
        oiFilterDisableForm(oi_filter_form);
    }
}

function oiFilterGetResults(oi_filter_form, results) {
    let ftype = oi_filter_form.dataset.filterType;
    const url = `/xhr/filter/${ftype}/`;
    const formData = getFormData(oi_filter_form);
    const detailPage = oi_filter_form.dataset.detailPage || false;

    oi.axios({
        method: "post",
        url: url,
        data: formData,
        headers: { "Content-Type": "application/json" },
        transformRequest: [function (data, headers) {
            oiFilterAjaxBeforesend(oi_filter_form, false);
            return data;
        }],
    })
    .then(function (resp) {
        if (resp.data.data.result_list) {
            if (resp.data.options) {
                const options = resp.data.options;
                for (const id in options) {
                    if (options.hasOwnProperty(id)) {
                        let el = document.getElementById(id);
                        if (el) {
                            el.innerHTML = options[id];
                        } else {
                            console.warn(`Element with ID "${id}" not found.`);
                        }
                    }
                }
            }

            if (resp.data.paginator && resp.data.paginator !== "") {
                const pageinput = oi_filter_form.querySelector('input[name="page"]');
                if (pageinput) {
                    pageinput.value = resp.data.paginator.next;
                }
            }

            if (results) {
                results.innerHTML = resp.data.data.result_list;
            }

            const oi_filter_amount = document.getElementById("oi-filter-amount");
            if (oi_filter_amount && resp.data.data.amount) {
                oi_filter_amount.innerHTML = resp.data.data.amount;
            }

            if (resp.data.result_list_lot) {
                const results_lot = document.getElementById("oi-filter-results-lot");
                if (results_lot) {
                    results_lot.innerHTML = resp.data.result_list;
                }
            }

            if (resp.data.result_list_land) {
                const results_land = document.getElementById("oi-filter-results-land");
                if (results_land) {
                    results_land.innerHTML = resp.data.result_list;
                }
            }

            if (resp.data.map_items && resp.data.map_items !== "") {
                const map_items = document.querySelector(".oi-all-map-items");
                if (map_items) {
                    map_items.innerHTML = resp.data.map_items;
                }
            }

            update_url(resp);

            if (window.afterResultsSuccess !== undefined) {
                window.afterResultsSuccess();
            }

            // The list map is created in common_map.html as oi.map.multi("gmap", ...),
            // so it is registered under the "gmap" key (not "oi-map"). Using the wrong
            // key left set_markers/fit unreachable, so markers never refreshed on filter
            // and card-hover sync broke for the cards injected by the AJAX response.
            if (oi.loaded.map.gmap && !detailPage) {
                // set_markers() matches each card's data-listing-type. Normalize the
                // filter type so it lines up with the type the cards actually render:
                // lot/mlslisting cards are "location", model cards are "spec".
                if (ftype === 'lot' || ftype === 'mlslisting') {
                    ftype = 'location';
                } else if (ftype === 'model') {
                    ftype = 'spec';
                }
                oi.loaded.map.gmap.set_markers(ftype);
                oi.loaded.map.gmap.fit();
            }
        }
    })
    .catch(function (error) {
        if (error.response) {
            if (error.response.status == 400) {
                let msg = "";
                const errors = error.response.data.errors;
                for (let err in errors) {
                    let x = errors[err];
                    msg = `${x.code} - ${x.description}\n`;
                }
                oiFilterEnableForm(oi_filter_form);
            } else if (error.response.status == 302) {
                window.location.href = error.response.data.data.redirect;
            }
        } else {
            console.error(error.message);
        }
    })
    .then(function () {
        const name_input = oi_filter_form.querySelector('input[name="m"]');
        if (name_input !== null) {
            name_input.value = "0";
        }
        oiFilterEnableForm(oi_filter_form);
    });
}

window.addEventListener("load", () => {
    const oi_filter_form = document.getElementById("oi-filter-form");
    const sortSelectEl = document.getElementById("oi-sort-select");
    const sortInputEl = document.getElementById("oi-sort-input");
    const oi_filter_results = document.getElementById("oi-filter-results");

    if (oi_filter_form) {
        const oi_filter_clickables = oi_filter_form.querySelectorAll(".oi-filter-click");
        const oi_filter_changables = oi_filter_form.querySelectorAll(".oi-filter-change");
        const oi_filter_reset = oi_filter_form.querySelectorAll(".oi-filter-reset");

        oi_filter_clickables.forEach((elem) => {
            elem.addEventListener("click", (e) => {
                e.preventDefault();
                oiFilterGetResults(oi_filter_form, oi_filter_results);
            });
        });

        oi_filter_changables.forEach((elem) => {
            elem.addEventListener("change", (e) => {
                e.preventDefault();
                oiFilterGetResults(oi_filter_form, oi_filter_results);
            });
        });

        const oi_geo_filter = oi_filter_form.querySelector('.oi-geo-filter');
        if (oi_geo_filter) {
            oi_geo_filter.addEventListener('change', (e) => {
                e.preventDefault();
                let url = e.target.selectedOptions[0].dataset.url;
                if (!url) {
                    const fType = oi_filter_form.dataset.filterType;
                    url = fType === 'spec'
                        ? '/new-homes/available/'
                        : '/new-homes/';
                }
                window.location.href = url;
            });
        }

        if (oi_filter_reset.length && oi_filter_results) {
            oi_filter_reset.forEach((btn) => {
                btn.addEventListener("click", (e) => {
                    e.preventDefault();
                    const to_clear = oi_filter_form.querySelectorAll(".oi-clear-on-reset");
                    to_clear.forEach((input) => {
                        if (input.type === "select-one") {
                            input.selectedIndex = 0;
                        } else if (input.id === "boyl-input") {
                            input.value = false;
                        } else if (input.type === "checkbox") {
                            input.checked = false;
                        }
                    });

                    const buttons_to_reset = oi_filter_form.querySelectorAll(".filter-button-on");
                    buttons_to_reset.forEach((btn) => {
                        btn.classList.remove("filter-button-on");
                    });

                    oiFilterGetResults(oi_filter_form, oi_filter_results);
                });
            });
        }
    }

    if (sortSelectEl && sortInputEl) {
        sortSelectEl.value = sortInputEl.value;
        sortSelectEl.addEventListener("change", (e) => {
            sortInputEl.value = e.target.value;
            sortInputEl.dispatchEvent(new Event("change"));
        });
    }

    window.addEventListener("popstate", () => {
        location.reload();
    });
});
